import { lazy, Suspense, useState } from "react";
import { BaseModuleProps, OSMModuleSettings } from "../../types/index.js";
import UsercentricsCMPWrapper from "../UsercentricsCMPWrapper.js";

const OSMModuleClient = lazy(() => import("./OSMModule.client.js"));

interface Props extends BaseModuleProps<OSMModuleSettings> {}

export const OSMModule = (props: Props) => {
  const [consentIsGiven, setConsentIsGiven] = useState(props.isPreview);

  return (
    <UsercentricsCMPWrapper
      serviceName="OpenStreetMap"
      languageId={props.translatedModule.translation.languageId}
      onConsentGiven={() => setConsentIsGiven(true)}
      consentIsGiven={consentIsGiven}
    >
      <Suspense fallback={<div>Loading...</div>}>
        <OSMModuleClient {...props} />
      </Suspense>
    </UsercentricsCMPWrapper>
  );
};
